module.exports = __webpack_public_path__ + "img/es-ct.3eb3a35a.svg";